import apiClient from './client';
import { Point } from '../types/point';

export const getUserPoints = () =>
  apiClient.get<Point[]>('/points/');

export const createPoint = (name: string, nearX?: number, nearY?: number, zoneId?: number) =>
  apiClient.post<Point>('/points/', { name, near_x: nearX, near_y: nearY, zone_id: zoneId });

export const deletePoint = (id: number) =>
  apiClient.delete(`/points/${id}`);

export const updatePoint = (id: number, name: string, color?: string, isImpassable?: boolean) =>
  apiClient.put<Point>(`/points/${id}`, { name, color, is_impassable: isImpassable });

/** Returns the 9×9 world area surrounding the point (for minimap). */
export const getPointArea = (id: number) =>
  apiClient.get<{ center: Point; points: Point[] }>(`/points/${id}/area`);
